"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.editorialPageProductBoxCarouselFragment = exports.editorialPageOlapicFragment = exports.editorialPageHeaderFragment = exports.editorialPageBannerTextFragment = exports.editorialPageBannerModuleFragment = exports.editorialPageBannerFragment = exports.editorialContentTypesFragment = exports.editorialArticlePageFragment = void 0;
var _fetching = require("@ori/fetching");
var _benefitsFragment = require("./benefitsFragment");
var _faqModuleFragment = require("./faqModuleFragment");
var _fiftyModuleFragment = require("./fiftyModuleFragment");
var _linkCarouselFragment = require("./linkCarouselFragment");
var _linkListFragment = require("./linkListFragment");
var _tableModuleFragment = require("./tableModuleFragment");
var _testimonialModuleFragment = require("./testimonialModuleFragment");
const editorialPageBannerTextFragment = exports.editorialPageBannerTextFragment = (0, _fetching.gql)`
  fragment EditorialPageBannerText on EditorialBannerText {
    text
    textLinks {
      title
      relativeUrl
    }
  }
`;
const editorialPageHeaderFragment = exports.editorialPageHeaderFragment = (0, _fetching.gql)`
  fragment EditorialPageHeader on EditorialHeader {
    __typename
    authorName
    id
    publishedDate
    isSharingEnabled
    headline
    extraLongHeadline
    text
    imageUrl
    links {
      data {
        __typename
      }
    }
    photographerName
    headlineStorybookColor
    backgroundStorybookColor
  }
`;
const editorialPageOlapicFragment = exports.editorialPageOlapicFragment = (0, _fetching.gql)`
  fragment EditorialPageOlapic on EditorialOlapic {
    __typename
    id
    categoryId
    product {
      productCode
    }
    type
  }
`;
const editorialPageProductBoxCarouselFragment = exports.editorialPageProductBoxCarouselFragment = (0, _fetching.gql)`
  fragment EditorialPageProductBoxCarousel on EditorialProductBoxCarousel {
    __typename
    headline
    products {
      productCode
    }
  }
`;
const editorialPageBannerModuleFragment = exports.editorialPageBannerModuleFragment = (0, _fetching.gql)`
  fragment EditorialPageBannerModule on EditorialBannerModule {
    backgroundColor {
      type
    }
    backgroundStorybookColor
    content {
      title
      titleColor
      titleStorybookColor
      titleSize
      caption
      showReadMoreOption
      horizontalAlignment
      textCollection {
        ...EditorialPageBannerText
      }
    }
    backgroundType
    backgroundVideo {
      autoplayOnScroll
      id
      playInLoop
      type
    }
    link {
      relativeUrl
      title
      data {
        __typename
        ... on Product {
          productCode
          labels {
            labelKey
            productLabelDomain
            title
          }
          concept {
            name
            products {
              productCode
            }
          }
          price {
            price {
              currentPrice
            }
          }
        }
      }
    }
    backgroundImage {
      url
    }
  }
`;
const editorialPageBannerFragment = exports.editorialPageBannerFragment = (0, _fetching.gql)`
  fragment EditorialPageBanner on EditorialBanner {
    __typename
    id
    layout
    modules {
      ...EditorialPageBannerModule
    }
  }
  ${editorialPageBannerModuleFragment}
  ${editorialPageBannerTextFragment}
`;
const editorialContentTypesFragment = exports.editorialContentTypesFragment = (0, _fetching.gql)`
  fragment EditorialContent on EditorialPageContent {
    ... on EditorialHeader {
      ...EditorialPageHeader
    }
    ... on EditorialOlapic {
      ...EditorialPageOlapic
    }
    ... on EditorialProductBoxCarousel {
      ...EditorialPageProductBoxCarousel
    }
    ... on EditorialBanner {
      ...EditorialPageBanner
    }
    ... on EditorialPage {
      ...EditorialPage
    }
    ... on EditorialTestimonialCarousel {
      ...TestimonialModule
    }
    ... on EditorialFrequentlyAskedQuestions {
      ...FaqModule
    }
    ... on EditorialFiftyBanner {
      ...FiftyBanner
    }
    ... on EditorialLinkList {
      ...LinkList
    }
    ... on EditorialBenefits {
      ...Benefits
    }
    ... on EditorialLinkCarousel {
      ...LinkCarousel
    }
    ... on TableModule {
      ...TableModule
    }
  }
  ${editorialPageHeaderFragment}
  ${editorialPageOlapicFragment}
  ${editorialPageProductBoxCarouselFragment}
  ${editorialPageBannerFragment}
  ${_testimonialModuleFragment.testimonialModuleFragment}
  ${_faqModuleFragment.faqModuleFragment}
  ${_fiftyModuleFragment.fiftyModuleFragment}
  ${_linkListFragment.linkListFragment}
  ${_linkCarouselFragment.linkCarouselFragment}
  ${_benefitsFragment.benefitsFragment}
  ${_tableModuleFragment.tableModuleFragment}
`;
const editorialArticlePageFragment = exports.editorialArticlePageFragment = (0, _fetching.gql)`
  fragment EditorialArticlePage on Application {
    editorialPage(channelType: Web, pageId: $pageId) {
      pageId
      contentItems {
        ...EditorialContent
      }
    }
  }
  ${editorialContentTypesFragment}
`;
